import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tool-header__inner" }
const _hoisted_2 = {
  key: 0,
  class: "tool-header__menu"
}
const _hoisted_3 = {
  key: 1,
  class: "tool-header__search"
}
const _hoisted_4 = {
  key: 2,
  class: "tool-header__help"
}

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'tool-header',
  props: {
    modifires: { type: [String, Array, Boolean] }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('tool-header', _ctx.modifires))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.menu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "menu")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.search)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "search")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.help)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "help")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})